module.exports = __webpack_public_path__ + "img/default-news-1.d72a5ebd.png";